import { ReactNode, useContext, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { AuthContext } from '../../contexts/AuthContext';
import { LoadingOverlay } from '../ui/LoadingOverlay';

const ProtectedRoute = ({ children }: { children: ReactNode }) => {
  const { isAuthenticated, isLoading } = useContext(AuthContext);
  const navigate = useNavigate();

  useEffect(() => {
    if (!isLoading && !isAuthenticated) {
      navigate('/login');
    }
  }, [isLoading, isAuthenticated, navigate]);

  if (isAuthenticated) {
    return <>{children}</>;
  }

  if (isLoading) {
    return <LoadingOverlay message="Authenticating..." />;
  }

  return null;
};

export default ProtectedRoute;